<template>
  <div id="screen"></div>
</template>
<script>
// import * as PIXI from 'pixi.js'
export default {
  mounted() {
    // Create the application
    // const app = new PIXI.Application();

    // Add the view to the DOM
    // this.$el.appendChild(app.view);

    // ex, add display objects
    // app.stage.addChild(new PIXI.Sprite(PIXI.Texture.fromImage('/migo.png')));

    // function render() {
    //     app.renderer.render(app.stage)
    //     requestAnimationFrame(render)
    //     console.log(1);
    // }
    // render()
  }
}
</script>

<style>
#screen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
</style>
